import { AccountCircle, Apartment, PetsOutlined } from "@mui/icons-material";
import AddHomeWorkIcon from "@mui/icons-material/AddHomeWork";
import ArticleIcon from "@mui/icons-material/Article";
import ImageIcon from "@mui/icons-material/Image";
import InventoryIcon from "@mui/icons-material/Inventory";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import PetsIcon from "@mui/icons-material/Pets";
import SettingsIcon from "@mui/icons-material/Settings";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import BloodtypeIcon from "@mui/icons-material/Bloodtype";
import * as BsIcons from "react-icons/bs";
import * as CgIcons from "react-icons/cg";
import { FaInfoCircle, FaRegThumbsUp, FaUser } from "react-icons/fa";
import { FaDatabase } from "react-icons/fa6";
import { GiCircuitry } from "react-icons/gi";
import { IoHomeSharp } from "react-icons/io5";
import * as MdIcons from "react-icons/md";
import { MdPendingActions } from "react-icons/md";
import {
  VIEW_APPOINTMENT,
  VIEW_CLINIC,
  VIEW_CUSTOM_INFORMATION_FIELD,
  VIEW_DOCUMENT_CATEGORIES,
  VIEW_INBOX,
  VIEW_LOGO_UPLOAD,
  VIEW_PENDING,
  VIEW_SPECIES_ADMINISTRATION,
  VIEW_STATIONARY,
  VIEW_TEMPLATES,
  VIEW_WAREHOUSE,
} from "../../../enums/PermissionTitles";
import * as tags from "../../../enums/PrivilegeTags";
import * as roleEnums from "../../../enums/Roles";
import * as UrlPath from "../../../enums/UrlPaths";
import ArchiveIcon from '@mui/icons-material/Archive';
const IGNORE = "Ignore";

const appointmentsPage = {
  path: UrlPath.APPOINTEMENTS,
  icon: <BsIcons.BsFillCalendarDateFill />,
  title: "Appointments",
  name: null,
  permission: VIEW_APPOINTMENT,
};

const NAV_BAR_PAGES = [
  {
    path: UrlPath.HOME,
    icon: <IoHomeSharp />,
    title: "Home",
    name: tags.HOME_PAGE,
    permission: IGNORE,
  },
  {
    path: UrlPath.HOME,
    icon: <IoHomeSharp />,
    title: "Home",
    name: tags.HOME_PAGE,
    role: roleEnums.MASTER,
    roles: [roleEnums.MASTER],
  },
  {
    path: UrlPath.PETS,
    icon: <MdIcons.MdOutlinePets />,
    title: "Pets",
    name: tags.USER_PAGE,
    permission: IGNORE,
    roles: [roleEnums.ADMIN, roleEnums.EMPLOYEE, roleEnums.USER],
  },
  appointmentsPage,
  {
    path: UrlPath.PENDING_APPOINTMENTS,
    icon: <MdPendingActions />,
    title: "Pending",
    name: tags.PENDING_APPOINTMENTS,
    permission: VIEW_PENDING,
    roles: [roleEnums.ADMIN, roleEnums.EMPLOYEE, roleEnums.MASTER],
  },
  {
    path: UrlPath.INBOX,
    icon: <MdIcons.MdMail />,
    title: "Inbox",
    name: tags.INBOX,
    permission: VIEW_INBOX,
  },
  {
    path: UrlPath.INBOX,
    icon: <MdIcons.MdMail />,
    title: "Inbox",
    name: tags.INBOX,
    role: roleEnums.MASTER,
  },
  {
    path: UrlPath.CLINIC_USERS,
    icon: <FaUser />,
    title: "ClinicUsers",
    name: tags.CLINIC_USERS,
    permission: VIEW_CLINIC,
    roles: [roleEnums.ADMIN, roleEnums.EMPLOYEE, roleEnums.MASTER],
  },
  {
    path: UrlPath.TEMPLATE,
    icon: <CgIcons.CgTemplate />,
    title: "Templates",
    name: tags.TEMPLATE_PAGE,
    permission: VIEW_TEMPLATES,
    roles: [roleEnums.ADMIN, roleEnums.EMPLOYEE, roleEnums.MASTER],
  },
  {
    path: UrlPath.SINGLE_CLINIC_WAREHOUSE,
    icon: <WarehouseIcon />,
    title: "Warehouse",
    name: tags.WAREHOUSE,
    permission: VIEW_WAREHOUSE,
    roles: [roleEnums.ADMIN, roleEnums.EMPLOYEE, roleEnums.MASTER],
  },
  {
    path: UrlPath.MASTER_CLINIC_USERS,
    icon: <FaUser />,
    title: "UsersOfClinics",
    role: roleEnums.MASTER,
    roles: [roleEnums.MASTER],
  },
  {
    path: UrlPath.SINGLE_CLINIC,
    icon: <Apartment />,
    title: "General",
    name: tags.MY_CLINIC,
    permission: VIEW_CLINIC,
    roles: [roleEnums.ADMIN, roleEnums.EMPLOYEE, roleEnums.MASTER],
  },
  {
    path: UrlPath.SINGLE_CLINIC_OPTIONS,
    icon: <SettingsIcon />,
    title: "Settings",
    name: tags.MY_CLINIC,
    permission: VIEW_CLINIC,
    roles: [roleEnums.ADMIN, roleEnums.EMPLOYEE, roleEnums.MASTER],
  },
  {
    path: UrlPath.SINGLE_CLINIC_EMPLOYEES,
    icon: <AccountCircle />,
    title: "Employees",
    name: tags.MY_CLINIC,
    permission: VIEW_CLINIC,
    roles: [roleEnums.ADMIN, roleEnums.EMPLOYEE, roleEnums.MASTER],
  },
  {
    path: UrlPath.SINGLE_CLINIC_WORKINGHOURS,
    icon: <AddHomeWorkIcon />,
    title: "WorkingHours",
    name: tags.MY_CLINIC,
    permission: VIEW_CLINIC,
    roles: [roleEnums.ADMIN, roleEnums.EMPLOYEE, roleEnums.MASTER],
  },
  {
    path: UrlPath.SAPS_HOME_PAGE,
    icon: <Inventory2Icon />,
    title: "Stationary",
    name: tags.SPAS_HOME_PAGE,
    permission: VIEW_STATIONARY,
    roles: [roleEnums.ADMIN, roleEnums.EMPLOYEE, roleEnums.MASTER],
  },
  {
    path: UrlPath.SAPS_ARCHIVE,
    icon: <ArchiveIcon />,
    title: "Archive",
    name: tags.SPAS_HOME_PAGE,
    permission: VIEW_STATIONARY,
    roles: [roleEnums.ADMIN, roleEnums.EMPLOYEE, roleEnums.MASTER],
  },
  {
    path: UrlPath.AI_ASSISTANT,
    icon: <GiCircuitry />,
    title: "AIAssistant",
    name: tags.SAPS_AI,
    permission: VIEW_STATIONARY,
    roles: [roleEnums.ADMIN, roleEnums.EMPLOYEE, roleEnums.MASTER],
  },
  {
    path: UrlPath.SINGLE_CLINIC_CHANGELOGO,
    icon: <ImageIcon />,
    title: "ChangeLogo",
    name: tags.MY_CLINIC,
    permission: VIEW_LOGO_UPLOAD,
    roles: [roleEnums.ADMIN, roleEnums.EMPLOYEE, roleEnums.MASTER],
  },
  {
    path: UrlPath.SINGLE_CLINIC_SPECIES,
    icon: <PetsIcon />,
    title: "Species",
    name: tags.MY_CLINIC,
    permission: VIEW_CLINIC,
    roles: [roleEnums.ADMIN, roleEnums.EMPLOYEE, roleEnums.MASTER],
  },
  {
    path: UrlPath.SINGLE_CLINIC_BLOOD_DONORS,
    icon: <BloodtypeIcon />,
    title: "BloodDonors",
    name: tags.BLOOD_DONORS,
    permission: VIEW_CLINIC,
    roles: [roleEnums.ADMIN, roleEnums.EMPLOYEE, roleEnums.MASTER],
  },
  {
    path: UrlPath.SINGLE_CLINIC_DOCUMENTCATEGORIES,
    icon: <ArticleIcon />,
    title: "DocumentCategories",
    name: tags.MY_CLINIC,
    permission: VIEW_DOCUMENT_CATEGORIES,
    roles: [roleEnums.ADMIN, roleEnums.EMPLOYEE, roleEnums.MASTER],
  },
  {
    path: UrlPath.SINGLE_CLINIC_INFORMATIONFIELDS,
    icon: <InventoryIcon />,
    title: "InformationFields",
    name: tags.MY_CLINIC,
    permission: VIEW_CUSTOM_INFORMATION_FIELD,
    roles: [roleEnums.ADMIN, roleEnums.EMPLOYEE, roleEnums.MASTER],
  }, 
  {
    path: UrlPath.ADMINISTRATION,
    icon: <FaDatabase />,
    title: "Clinics",
    name: tags.ADMINISTRATION,
    permission: VIEW_SPECIES_ADMINISTRATION,
    role: roleEnums.MASTER,
    roles: [roleEnums.MASTER],
  },
  {
    path: UrlPath.SPECIES_ADMINISTRATION,
    icon: <PetsOutlined />,
    title: "SpeciesPlural",
    name: tags.SPECIES_ADMINISTRATION,
    permission: VIEW_SPECIES_ADMINISTRATION,
    role: roleEnums.MASTER,
    roles: [roleEnums.MASTER],
  },
  {
    path: UrlPath.ABOUT_US,
    icon: <FaInfoCircle />,
    title: "AboutUs",
    name: tags.ABOUT_US,
    permission: IGNORE,
  },
  {
    path: UrlPath.FEEDBACK_SUBMIT,
    icon: <FaRegThumbsUp />,
    title: "Feedback",
    name: tags.FEEDBACK,
    permission: IGNORE,
  },
];

const STACIONAR_MAIL_PAGES = [
  {
    path: UrlPath.SAPS_HOME_PAGE,
    icon: <Inventory2Icon />,
    title: "Stationary",
    name: tags.SPAS_HOME_PAGE,
    permission: IGNORE,
  },
  {
    path: UrlPath.AI_ASSISTANT,
    icon: <GiCircuitry />,
    title: "AIAssistant",
    name: tags.SAPS_AI,
    permission: IGNORE,
  },
];

export { NAV_BAR_PAGES, STACIONAR_MAIL_PAGES };
